import { useMemo } from "react";

const NAMES = ["C", "C#", "D", "D#", "E", "F", "F#", "G", "G#", "A", "A#", "B"];
export const noteName = (p) => `${NAMES[p % 12]}${Math.floor(p / 12) - 1}`;
const STEP = 0.25; // beats (16th)
const CELL_W = 22;
const CELL_H = 16;

// Piano-roll grid: notes in beats. Click empty cell → add 16th note, click a note → remove it.
export default function StepGrid({ notes, onChange, bars = 2, lo = 48, hi = 72, drums = false }) {
  const steps = bars * 16;
  const rows = useMemo(() => { const r = []; for (let p = hi; p >= lo; p--) r.push(p); return r; }, [lo, hi]);
  const toggle = (pitch, step) => {
    const start = step * STEP;
    const hit = notes.findIndex((n) => n.pitch === pitch && start >= n.start && start < n.start + n.duration);
    if (hit >= 0) onChange(notes.filter((_, i) => i !== hit));
    else onChange([...notes, { pitch, start, duration: drums ? 0.2 : STEP, velocity: 100 }]);
  };
  const drumLabel = { 0: "Kick", 2: "Snare", 3: "Clap", 6: "Hat", 8: "Hat", 10: "Hat" };
  return (
    <div className="overflow-auto rounded-xl border border-border bg-background" data-testid="step-grid">
      <div className="relative" style={{ width: 44 + steps * CELL_W, height: rows.length * CELL_H }}>
        {rows.map((p, ri) => (
          <div key={p} className={`absolute left-0 right-0 flex ${NAMES[p % 12].includes("#") ? "bg-muted/30" : ""}`} style={{ top: ri * CELL_H, height: CELL_H }}>
            <div className={`w-11 shrink-0 text-[9px] font-mono pr-1 text-right leading-4 ${p % 12 === 0 ? "text-primary" : "text-muted-foreground"}`}>{drums ? (drumLabel[p % 12] || "·") : noteName(p)}</div>
            {Array.from({ length: steps }, (_, s) => (
              <button key={s} type="button" onClick={() => toggle(p, s)} className={`shrink-0 border-r border-b border-border/40 hover:bg-primary/10 ${s % 4 === 0 ? "border-l border-l-border" : ""}`} style={{ width: CELL_W, height: CELL_H }} data-testid={`cell-${p}-${s}`} aria-label={`${noteName(p)} step ${s + 1}`} />
            ))}
          </div>
        ))}
        {notes.map((n, i) => {
          const ri = rows.indexOf(n.pitch);
          if (ri < 0) return null;
          return (
            <button key={i} type="button" onClick={() => onChange(notes.filter((_, j) => j !== i))} title={`${noteName(n.pitch)} · ${n.start}b · ${n.duration}b`}
              className="absolute rounded-sm bg-primary/80 hover:bg-destructive/80 border border-primary text-[8px] font-mono text-primary-foreground overflow-hidden"
              style={{ left: 44 + (n.start / STEP) * CELL_W + 1, top: ri * CELL_H + 1, width: Math.max(CELL_W - 2, (n.duration / STEP) * CELL_W - 2), height: CELL_H - 2, opacity: 0.55 + 0.45 * (n.velocity || 100) / 127 }}
              data-testid={`note-${i}`} />
          );
        })}
      </div>
    </div>
  );
}
